// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { TrafficconfigTrafficConfig } from '../models/index';
import {
  TrafficconfigTrafficConfigFromJSON,
  TrafficconfigTrafficConfigToJSON,
} from '../models/index';

export interface V1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigGetRequest {
  isolationUnit: string;
  region: string;
}

export interface V1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigPutRequest {
  isolationUnit: string;
  region: string;
  trafficConfig: TrafficconfigTrafficConfig;
}

export interface V1OrchestrasOrchestraTrafficConfigGetRequest {
  orchestra: string;
}

/**
 *
 */
export class TrafficConfigApi extends runtime.BaseAPI {
  /**
   * Get a traffic configuration by isolation unit and region. Does not require Private Link on the isolation unit (read is allowed for any mapped orchestra). Use PUT to mutate; PUT still enforces Private Link.
   * Get a traffic configuration
   */
  async v1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigGetRaw(
    requestParameters: V1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TrafficconfigTrafficConfig>> {
    if (requestParameters['isolationUnit'] == null) {
      throw new runtime.RequiredError(
        'isolationUnit',
        'Required parameter "isolationUnit" was null or undefined when calling v1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigGet().',
      );
    }

    if (requestParameters['region'] == null) {
      throw new runtime.RequiredError(
        'region',
        'Required parameter "region" was null or undefined when calling v1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/isolation-units/{isolation-unit}/regions/{region}/traffic-config`;
    urlPath = urlPath.replace(
      `{${'isolation-unit'}}`,
      encodeURIComponent(String(requestParameters['isolationUnit'])),
    );
    urlPath = urlPath.replace(
      `{${'region'}}`,
      encodeURIComponent(String(requestParameters['region'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      TrafficconfigTrafficConfigFromJSON(jsonValue),
    );
  }

  /**
   * Get a traffic configuration by isolation unit and region. Does not require Private Link on the isolation unit (read is allowed for any mapped orchestra). Use PUT to mutate; PUT still enforces Private Link.
   * Get a traffic configuration
   */
  async v1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigGet(
    requestParameters: V1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TrafficconfigTrafficConfig> {
    const response =
      await this.v1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Update a traffic configuration by isolation unit and region.
   * Update a traffic configuration
   */
  async v1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigPutRaw(
    requestParameters: V1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TrafficconfigTrafficConfig>> {
    if (requestParameters['isolationUnit'] == null) {
      throw new runtime.RequiredError(
        'isolationUnit',
        'Required parameter "isolationUnit" was null or undefined when calling v1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigPut().',
      );
    }

    if (requestParameters['region'] == null) {
      throw new runtime.RequiredError(
        'region',
        'Required parameter "region" was null or undefined when calling v1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigPut().',
      );
    }

    if (requestParameters['trafficConfig'] == null) {
      throw new runtime.RequiredError(
        'trafficConfig',
        'Required parameter "trafficConfig" was null or undefined when calling v1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    let urlPath = `/v1/isolation-units/{isolation-unit}/regions/{region}/traffic-config`;
    urlPath = urlPath.replace(
      `{${'isolation-unit'}}`,
      encodeURIComponent(String(requestParameters['isolationUnit'])),
    );
    urlPath = urlPath.replace(
      `{${'region'}}`,
      encodeURIComponent(String(requestParameters['region'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: TrafficconfigTrafficConfigToJSON(
          requestParameters['trafficConfig'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      TrafficconfigTrafficConfigFromJSON(jsonValue),
    );
  }

  /**
   * Update a traffic configuration by isolation unit and region.
   * Update a traffic configuration
   */
  async v1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigPut(
    requestParameters: V1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TrafficconfigTrafficConfig> {
    const response =
      await this.v1IsolationUnitsIsolationUnitRegionsRegionTrafficConfigPutRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * Get a traffic configuration by orchestra name. Response matches the isolation-unit route. Does not require Private Link on the isolation unit (read is allowed for any mapped orchestra). Mutations use PUT on the isolation-unit route only; that PUT still enforces Private Link.
   * Get a traffic configuration
   */
  async v1OrchestrasOrchestraTrafficConfigGetRaw(
    requestParameters: V1OrchestrasOrchestraTrafficConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TrafficconfigTrafficConfig>> {
    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling v1OrchestrasOrchestraTrafficConfigGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/orchestras/{orchestra}/traffic-config`;
    urlPath = urlPath.replace(
      `{${'orchestra'}}`,
      encodeURIComponent(String(requestParameters['orchestra'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      TrafficconfigTrafficConfigFromJSON(jsonValue),
    );
  }

  /**
   * Get a traffic configuration by orchestra name. Response matches the isolation-unit route. Does not require Private Link on the isolation unit (read is allowed for any mapped orchestra). Mutations use PUT on the isolation-unit route only; that PUT still enforces Private Link.
   * Get a traffic configuration
   */
  async v1OrchestrasOrchestraTrafficConfigGet(
    requestParameters: V1OrchestrasOrchestraTrafficConfigGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TrafficconfigTrafficConfig> {
    const response = await this.v1OrchestrasOrchestraTrafficConfigGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
